module.exports = __webpack_public_path__ + "img/hero-bg.963ac592.svg";